import { FontSizes, FontWeights, Text } from '@fluentui/react';

export const FooterBarComponent = () => {
  return (
    <div className="footerBar">
      <Text style={{color: 'gray', fontSize: FontSizes.size16}}>©2023</Text>
      <a href="https://www.ichtys.com.ar/" target="_blank" rel="noopener noreferrer">
        <img 
          height={40} 
          style={{marginTop: 3}}
          src={require('../../assets/img/logoichtys-technology.png')}
          alt="Ichtys Technology"
        />
      </a>
    </div>
  );
};
